'use client';

import classNames from 'classnames';
import type { FC, MouseEventHandler } from 'react';
import type { IconName } from '../utils/icon-name';
import styles from './icon.module.css';
import { LazySvgMap } from './lazy-svg-map';

export type IconProps = {
  className?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
};

// passing shiftColor to svg based component is causing a console error
const SVGIcon: FC<IconProps & { name: IconName }> = ({ name, className, ...props }) => {
  const Component = LazySvgMap[name];

  return Component && <Component {...props} className={classNames(styles.icon, className)} />;
};

export const Icon: FC<IconProps & { name: IconName }> = ({ ...props }) => <SVGIcon {...props} />;
